/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 12/10/14
 * Time: 9:46 AM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";
    var CP_CONST = require("connection-const");
    var BaseModel = require("models/BaseModel");
    var LEConfig = require("assets/config/le-env-conf");
    var ConnectionPanelContextModel = {};

    var panelStates = {
        mini: 1,
        box: 2,
        panel: 3,
        sidePanel: 4
    };

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {
        ConnectionPanelContextModel = BaseModel.extend({
            name: "ConnectionPanelContextModel",
            defaults: {
                holdHover: false,
                isOpen: false,
                //     isHandleMinimized:true,
                selectedTab: CP_CONST.TABS.CONTENT,
                selectedKP: null, //selected kp is kp snippet model
                selectedTicket: null,
                selectedNotification: null,
                referrerAction: null,
                context: {
                    area: null,
                    page: null,
                    activities: []
                },
                locale: "en-US",
                area: "LECampaigns",
                chatNotificationsCounter: 0,
                notificationCenterEventsCounter: 0,
                chatIsActive: false,
                isSoundEnabled: true,
                state: 0,
                previousState: 0,
                iframeWrapper: false,
                extendedViewIsOpen: false,
                searchTerm: "",
                accountName: "",
                salesForceId: null,
                ticketViewIsOpen: false,
                topElement: "",
                chatMode: CP_CONST.CHAT_MODE.NORMAL,
                newKPsCounter: 0,
                contacts: null,
                notificationCenterEnabled: false
            },

            initialize: function () {
                this.readKPsStoragePrefix = LE.sessionManager.getAccountId() + ':' + LE.sessionManager.getUserId() + ':readNewKPs';
            },


            switchChatMode: function () {
                var CHAT_MODE = CP_CONST.CHAT_MODE;
                var currentChatMode = this.get('chatMode');
                if (currentChatMode === CHAT_MODE.NORMAL) {
                    this.set('chatMode', CHAT_MODE.FALLBACK);
                } else {
                    this.set('chatMode', CHAT_MODE.NORMAL);
                }
            },

            isNormalChatMode: function () {
                return this.get('chatMode') === CP_CONST.CHAT_MODE.NORMAL;
            },

            computeState: function () {
                if (this.get('selectedKP') || this.get('selectedTicket')) {
                    this.set({previousState: this.get('state'), state: panelStates.sidePanel}, {silent: true});
                }
                else if (this.get('isOpen')) {
                    this.set({previousState: this.get('state'), state: panelStates.panel}, {silent: true});
                }
                else {
                    this.set({previousState: this.get('state'), state: panelStates.box}, {silent: true});
                }
            },

            getTopElement: function () {
                return this.get("topElement");
            },
            setTopElement: function (value) {
                this.set("topElement", value);
            },
            getSelectedKP: function () {
                return this.get("selectedKP");
            },
            setCanAddSeverity: function (value) {
                return this.set('canAddSeverity',value);
            },
            canAddSeverity: function () {
                return this.get('canAddSeverity') === true;
            },
            setSalesForceId: function (value) {
                this.set("salesForceId", value);
            },
            getSalesForceId: function () {
                return this.get("salesForceId");
            },
            setAccountName: function (value) {
                this.set("accountName", value);
            },
            getAccountName: function () {
                return this.get("accountName");
            },

            setContacts: function (value) {
                this.set("contacts", value);
            },
            getContacts: function () {
                return this.get("contacts");
            },

            getAccountId: function () {
                return this.get("accountId");
            },

            isOpen: function () {
                return this.get("isOpen");
            },

            setIsOpen: function (value) {
                this.set("isOpen", value);
            },

            isTicketViewOpen: function () {
                return this.get("ticketViewIsOpen");
            },

            isTicketListOpen: function () {
                return this.get("extendedViewIsOpen");
            },

            setTicketViewIsOpen: function (value) {
                this.set("ticketViewIsOpen", value);
            },

            setNotificationViewIsOpen: function (value) {
                this.set("notificationViewIsOpen", value);
            },

            isNotificationViewOpen: function () {
                this.set("notificationViewIsOpen");
            },

            setTicketListIsOpen: function (value) {
                this.set("extendedViewIsOpen", value);
            },

            getSelectedTicket: function () {
                return this.get("selectedTicket");
            },

            setSelectedTicket: function (value) {
                this.set("selectedTicket", value);
            },

            getSelectedNotification: function () {
                return this.get("selectedNotification");
            },

            setSelectedNotification: function (value) {
                this.set("selectedNotification", value);
            },

            getSupportSiteId: function () {
                if (this.isNormalChatMode()) {
                    return LE.LPtag_mtaconfig.siteId;
                } else {
                    return LEConfig.connectionPanelChatSettings.fallbackSupportAccount.siteId;
                }
            },

            getSupportAccountAppKey: function () {
                if (this.isNormalChatMode()) {
                    return LEConfig.LPApiAppKey;
                } else {
                    return LEConfig.connectionPanelChatSettings.fallbackSupportAccount.appKey;
                }
            },

            getNotificationsCounter: function () {
                return this.get('notificationCenterEventsCounter');
            },

            setNotificationsCollection: function (collection) {
                this.notificationCollection = collection;
                //this is for updating the notifications counter
                this.listenTo(this.notificationCollection, 'change:isRead', this._updateNotificationsCounter);
                this.listenTo(this.notificationCollection, 'add', this._updateNotificationsCounter);
                this.listenTo(this.notificationCollection, 'remove', this._updateNotificationsCounter);
            },

            _updateNotificationsCounter: function () {
                this.set("notificationCenterEventsCounter", this.notificationCollection.countUnreadNotifications());
                this.set("hasCriticalNotifications", this.notificationCollection.hasCritical());
            },

            getSelectedTab: function () {
                return this.get('selectedTab');
            },

            selectNotificationTab: function () {
                this.set('selectedTab', CP_CONST.TABS.NOTIFICATION);
            },

            setNewSnippetsCollection: function (collection) {
                this.set('newSnippetsCollection', collection);
                this._computeNewKpsCounter();
                this.listenTo(collection, 'change:isRead', this._changeNewKPsIsRead, this);
                this.listenTo(collection, 'add', this._computeNewKpsCounter, this);
            },

            _changeNewKPsIsRead: function (model, value) {
                if (this._getReadKPsList().indexOf(model.get('slug')) === -1) {
                    this._saveNewKPsAsRead(model.get('slug'));
                }
                this._computeNewKpsCounter();
            },

            _computeNewKpsCounter: function () {
                var newUnreadKPsCounter = 0;
                var newUnreadKPs = this.get('newSnippetsCollection').where({isRead: false});
                var readKPs = this._getReadKPsList();
                _.each(newUnreadKPs, function (current) {
                    if (readKPs.indexOf(current.get('slug')) === -1) {
                        newUnreadKPsCounter++;
                    }
                });
                this.set('newKPsCounter', newUnreadKPsCounter);
            },

            getNewKPsCounter: function () {
                return this.get('newKPsCounter');
            },

            setNotificationCenterEnabled: function (value) {
                this.set('notificationCenterEnabled',value);
            },

            isNotificationCenterEnabled: function () {
                return this.get('notificationCenterEnabled');
            },

            _getReadKPsList: function () {
                if (!this.readNewKPs) {
                    this.readNewKPs = JSON.parse(LEConnection.parentManager.getFromLocalStorage(this.readKPsStoragePrefix)) || [];
                }
                return this.readNewKPs;
            },

            _saveNewKPsAsRead: function (slug) {
                this._getReadKPsList().push(slug);
                if (LEConnection.parentManager && LEConnection.parentManager.getFromLocalStorage) {
                    if (LEConnection.parentManager && LEConnection.parentManager.saveInLocalStorage) {
                        LEConnection.parentManager.saveInLocalStorage(this.readKPsStoragePrefix, JSON.stringify(this.readNewKPs));
                    }
                }
            },

            resetMessagingContacts: function () {
                var contacts = this.get('contacts');
                if(contacts.length){
                    contacts.forEach( contact => {
                        if(contact.isMessagingContact()){
                            contact.isMessagingConversationLoaded = false;
                        }
                    });
                }
            }
        });
    });
    return ConnectionPanelContextModel;
});
